import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  FormInput,
  Segment,
  Provider,
} from "@fluentui/react-northstar";
import ImageTitleContainer from "../ImageTitleContainer";
import ForgotPasswordImage from "../../../assets/images/undraw_forgot_password_gi2d.svg";
import Constants from "../../../constants/text-constants";

const ForgottenPasswordEnterTextStep = (props) => {
  const {
    title,
    subtitle,
    value,
    testId,
    placeholder,
    handleValueChange,
    id,
    nextClicked,
    valid,
    gotoSignIn,
    inputErrorMessage,
    loading,
  } = props;

  const onChange = (event) => {
    if (handleValueChange) {
      handleValueChange(event.target.id, event.target.value);
    }
  };

  const bgClass = "forgotten-password-text-step segment";

  return (
    <Provider.Consumer
      render={(theme) => (
        <Segment
          className={
            theme.siteVariables.themeString === "dark"
              ? bgClass + " dark"
              : bgClass
          }
          data-testid={testId + "Segment"}
        >
          <ImageTitleContainer
            image={ForgotPasswordImage}
            title={title}
            subTitle={subtitle}
            testId={testId}
          >
            <FormInput
              id={id}
              fluid
              data-testid={testId + "Input"}
              onChange={onChange}
              placeholder={placeholder}
              value={value}
              error={inputErrorMessage}
              errorMessage={inputErrorMessage}
              disabled={loading}
            />
            <Button
              data-testid={testId + "NextBtn"}
              primary
              content={Constants.NEXT}
              onClick={nextClicked}
              disabled={!valid || loading}
              loading={loading}
            />
            <Button
              text
              content={Constants.BACK_TO_SIGN_IN}
              data-testid={testId + "BackBtn"}
              onClick={gotoSignIn}
              disabled={loading}
            />
          </ImageTitleContainer>
        </Segment>
      )}
    ></Provider.Consumer>
  );
};

ForgottenPasswordEnterTextStep.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  value: PropTypes.string,
  testId: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string.isRequired,
  nextClicked: PropTypes.func,
  handleValueChange: PropTypes.func,
  gotoSignIn: PropTypes.func,
  valid: PropTypes.bool,
  inputErrorMessage: PropTypes.string,
  loading: PropTypes.bool,
};

ForgottenPasswordEnterTextStep.defaultProps = {
  title: Constants.FORGOT_YOUR_PASSWORD,
  subtitle: "",
  value: "",
  testId: "",
  placeholder: "",
  loading: false,
};

export default ForgottenPasswordEnterTextStep;
